export default "__VITE_ASSET__DUPunc_b__"